import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import type { Scene } from '@babylonjs/core/scene';
import type { ITransformComponent3 } from '@seddi/scene';
import { createQuaternion, createVector3 } from '@seddi/ui-babylon-core';
import type { PieceRenderable } from './pieceRenderable';
import type { SeamRenderable } from './seamRenderable';

export class EntityRenderable {
  /**
   * Unique ID.
   */
  public readonly id: string;

  /**
   * Scene.
   */
  public readonly scene: Scene;

  /**
   * Transform node.
   */
  public readonly node: TransformNode;

  /**
   * Piece.
   */
  public piece?: PieceRenderable;

  /**
   * Seam.
   */
  public seam?: SeamRenderable;

  /**
   * Create renderable.
   * @param id - ID.
   * @param scene - Scene this renderable will be added to.
   */
  constructor(id: string, scene: Scene) {
    this.id = id;
    this.scene = scene;
    this.node = new TransformNode(id, scene);
  }

  /**
   * Update transform.
   * @param transform - Transform 3D component.
   */
  public updateTransform(transform: ITransformComponent3) {
    if (transform.position) {
      this.node.position = createVector3(transform.position);
    }
    if (transform.rotation) {
      this.node.rotationQuaternion = createQuaternion(transform.rotation);
    }
  }
}
